import { Factory } from "./../core/factory";

import { registerTextMark, TextMark } from "./text";

export class LabelMark extends TextMark {
    constructor() {
        super(...arguments), this.skipEncode = !1;
    }
    getRule() {
        return this._rule;
    }
    setRule(rule) {
        this._rule = rule;
    }
    getTarget() {
        return this._target;
    }
    setTarget(target) {
        this._target = target, this._rule || this.setRule(target.type);
    }
    getComponent() {
        return this._component;
    }
    setComponent(component) {
        this._component = component;
    }
    render() {}
}

LabelMark.type = "text", LabelMark.constructorType = "label";

export const registerLabelMark = () => {
    registerTextMark(), Factory.registerMark(LabelMark.constructorType, LabelMark);
};
//# sourceMappingURL=label.js.map
